import React, { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { selectGeolocationStatus } from '../../store/geolocation/geolocation.selectors'
import { setGeolocationStatus } from '../../store/geolocation/geolocationSlice'
import {
  GEOLOC_STATUS_ACTIVE,
  GEOLOC_STATUS_FOLLOW,
  MAPLIBRE_EVENT_MOVE,
  MAPLIBRE_EVENT_ZOOM
} from '../../store/map/map.constants'
import { debounce } from '../../utils/function'
import { MAP_STORE_UPDATE_DELAY } from './map.constants'
import { withMapInitialized } from './map.utils'
import { useEffectWithMapContext } from './MapContext'

const Geolocation = () => {
  const status = useSelector(selectGeolocationStatus)
  const dispatch = useDispatch()

  const onMapMove = useCallback(
    event => {
      const statusIsFollow = status === GEOLOC_STATUS_FOLLOW
      const moveFromUser = !event.fromAppAction && event.type === MAPLIBRE_EVENT_MOVE
      if (statusIsFollow && moveFromUser) {
        dispatch(setGeolocationStatus(GEOLOC_STATUS_ACTIVE))
      }
    },
    [status, setGeolocationStatus]
  )

  const onMapMoveDelayed = debounce(onMapMove, MAP_STORE_UPDATE_DELAY)

  useEffectWithMapContext(
    map => {
      map.on(MAPLIBRE_EVENT_MOVE, onMapMoveDelayed)
      map.on(MAPLIBRE_EVENT_ZOOM, onMapMoveDelayed)

      return () => {
        map.off(MAPLIBRE_EVENT_MOVE, onMapMoveDelayed)
        map.off(MAPLIBRE_EVENT_ZOOM, onMapMoveDelayed)
      }
    },
    [onMapMoveDelayed]
  )

  return <></>
}

export default withMapInitialized(Geolocation)
